export function OutlineFileIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0749 18.9989V8.83045C19.0749 8.29779 18.8638 7.79392 18.4895 7.41482L14.6601 3.58544C14.2858 3.21114 13.7771 3 13.2445 3H7.01572C5.91201 3 5.01465 3.89736 5.01465 5.00107V18.9989C5.01465 20.1026 5.91201 21 7.01572 21H17.0786C18.1823 21 19.0797 20.1026 19.0797 18.9989H19.0749Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M13.0764 3.00391V7.28916C13.0764 8.23451 13.8442 9.00231 14.7896 9.00231H19.0748"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
